

	function ContactForm(settings) {
		this.className 	= "ContactForm";
		this.name		= "contact/popup";

		if(settings) this.setup(settings)
	}
	ContactForm.inheritsFrom( PopupForm );
	ContactForm.prototype.setup = function(settings = {}) {

		//this.singlePage = !!nav.getState().nextParams.single; 
		this.singlePage = true; // force eccord forms into single page mode

		if(!this.service) this.service = settings.service ?? false;

		//General variable setup
		this.autoAdvance	= true;
		this.questionLabels = {}; //todo better

		this.$overlay = $('.js-contact-popup');

		//Gather the data from the child class
		const instructions = this.instructions();
		const additionalQuestions = this.additionalQuestions()
		const questions = instructions.questions.concat(additionalQuestions);
		const additionalPages = this.additionalPages();

		let pages = instructions.pages.concat(additionalPages);
		pages = this.processPages(pages);

		this.data = {
			errors: {
				general: "Please complete the required fields highlighted above."
			},
			pages: pages,
			questions: questions
		};

		this.runParent("setup");

	};
	ContactForm.prototype.processPages = function(pages) {
		pages.forEach(page => {
			//Fill in the defaults
			if(!page.initData) page.initData = this.standardInitData;
		});

		if(this.singlePage) {
			//Combine pages
			var combinedPage = {
				name: "index",
				questions: [],
				include: () => {
					return true;
				},
				initData: this.standardInitData,
				questionIncludes: {}
			};
			pages.forEach(page => {
				//Put the include functino onto each quesiton
				if (page.questions) page.questions.forEach(question => {
					combinedPage.questionIncludes[question] = page.include;
				})
				//Combine all the questions into one
				if (page.questions) combinedPage.questions = combinedPage.questions.concat(...page.questions);
			});
			var singlePages = [combinedPage,{ name: "complete", 	count: false }];
			// console.log(singlePages);
			return singlePages;
		}

		return pages;


	};
	ContactForm.prototype.getQuestions = function(names) {
		return names.map(name => this.getQuestion(name));
	}
	ContactForm.prototype.getQuestion = function(name) {
		const question = this.data.questions.find(t => t.name === name);
		this.pluralize(question);
		return question;
	}
	ContactForm.prototype.pluralize = function(question) {

		// Set question label
		question.label = this.getQuestionTitle(question);

		// Set answer labels
		const isPlural = this.isPlural();
		if(question.answers && question.answers.length) {
			for(let index in question.answers) {
				const answer = question.answers[index];

				answer.visible = true;
				if(answer.hide && !isPlural && answer.hide === "singular") answer.visible = false;

				if(answer.value && answer.value === true){
					answer.value = answer.labels;
				}

				// Convert labels
				answer.label = answer.labels;
				if(answer.labels && answer.labels.singular && answer.labels.plural) {
					answer.label = isPlural ? answer.labels.plural : answer.labels.singular;
					// Value = plural label if defined or use label value
					if(!answer.value || answer.value === true){
						answer.value = answer.label;
					}
				}
			}
		}

		return question; //We've updated the original too, so might be no need to return.
	}
	ContactForm.prototype.getQuestionTitle = function(question) {
		const isPlural = this.isPlural();

		//Accept a question or a name - if it's a name, turn in to a question.
		if(typeof(question) === 'string') question = this.getQuestion(question);

		if(question.labels && question.labels.singular && question.labels.plural) {
			return isPlural ? question.labels.plural : question.labels.singular;
		}else{
			return question.labels;
		}
	};
	ContactForm.prototype.getAnswerValue = function(question, answer) {
		const isPlural = this.isPlural();

		let value = answer;

		//Accept a question or a name - if it's a name, turn in to a question.
		if(typeof(question) === 'string') question = this.getQuestion(question);

		const foundAnswer = question && question.answers && question.answers.find(t => t.name === answer);
		if(foundAnswer){
			if(!foundAnswer.value || foundAnswer.value === true){
				value = foundAnswer.label;
			}else{
				value = foundAnswer.value;
			}
		}

		value = (typeof(value) === 'object' ? (isPlural ? value.plural : value.singular) : value);
		return value;
	};
	ContactForm.prototype.getQuestionPriority = function(question) {
		//Accept a question or a name - if it's a name, turn in to a question.
		if(typeof(question) === 'string') question = this.getQuestion(question);

		return question.priority ?? false;
	};
	ContactForm.prototype.getQuestionDetails = function(question, answer) {

		//Accept a question or a name - if it's a name, turn in to a question.
		if(typeof(question) === 'string') question = this.getQuestion(question);

		const questionTitle 	= this.getQuestionTitle(question);
		const answerValue 		= this.getAnswerValue(question, answer);
		const questionPriority 	= this.getQuestionPriority(question);

		return {
			title: questionTitle,
			answer: answerValue,
			priority: questionPriority,
		}
	};
	ContactForm.prototype.onRender = function(e) {
		// this.setupReveals();

		if(this.singlePage) this.checkQuestionIncludeVisibilities();
	};
	ContactForm.prototype.onSavePage = function(e) {
		//console.log("On save page", e);
	};
	ContactForm.prototype.checkQuestionIncludeVisibilities = function(values) {
		if(this.page.name!="complete") {
			this.page.questions.forEach(question => {
				const include = this.page.questionIncludes[question];
				let show = true;

				if(!include){
					//true
				}else{

					if(!values) values = this.values;
					var _this = {values:values};
					var result = include.call(_this);
					show = result;

				}

				this.$content.find(".question."+question).toggle(show);
			})
		}
	}
	ContactForm.prototype.onInputChanged = function(e) {

		if(!this.autoAdvance) return false;


		if(this.singlePage){
			//Something's changed so check what needs to be shown
			var fakeValue = {};
			this.page.inputs.forEach(input => {
				fakeValue[input.name] = input.value;
			})

			const fakeValues = Object.assign({}, this.values, fakeValue);
			const backup = this.values;
			this.values = fakeValues;
			this.checkQuestionIncludeVisibilities(fakeValues)
			this.values = backup;

		}


		//debugger;

		const input = e.input;
		const page = e.page;


		if(input.type == "input") {
			return this.checkPage();
		}

		// Show and hide next question
		if(input.type == "buttons"){

			const $buttons = input.$input.find('.button');
			let nextQuestionVisibility = false;
			$buttons.each(function() {
				const $button = $(this);
				if($button.hasClass('js-show-next-field') && $button.hasClass('selected')){
					nextQuestionVisibility = true;
				}
			});

			const $nextQuestion = $buttons.parents('.question:first').next('.js-reveal-question');

			$nextQuestion.toggleClass('hidden', !nextQuestionVisibility);
			if(this.recalcVisibilities) this.recalcVisibilities();
		}

		if(!input.latestChangeManual) return;
		//if(!input.latestChangeManual) return;

		if(input.type == "buttons"){
			const name = input.name;

			// Auto advance if this is the last visible input on page.
			const validInputs = page.inputs.filter(input => input.valid);
			const visibleInputs = page.inputs.filter(input => input.visible);
			const inputIndex = visibleInputs.findIndex(input => input.name == name);

			const isLastInput = (inputIndex == visibleInputs.length-1 || validInputs.length === visibleInputs.length);
			if(isLastInput && !input.multiple) {
				return this.autoCheckPage();
			}
		}

	};
	ContactForm.prototype.processSubmissionData = function(e) {
		const final = {};

		for(let name in e.values) {
			const value = e.values[name];

			const details = this.getQuestionDetails(name, value);
			if(details){
				let answer = details.answer;

				// Create string from processed value parts
				const values = [];
				const valueParts = answer.split("; ");
				if(valueParts && valueParts.length > 0){
					valueParts.forEach((value) => values.push(this.getAnswerValue(name, value)));
					answer = valueParts.length>1 ? values.join("; ") : valueParts[0];
				}

				final[name] = {
					priority: details.priority ? details.priority : "",
					label: details.title ? details.title : (name.substr(0,1).toUpperCase() + name.substr(1)).replace(/\-/g," "),
					value: answer,
				}
			}
		};

		final['service'] = this.service;

		return final;
	};
	ContactForm.prototype.isPlural = function() {
		const property = this.values.property;
		return (property === "portfolio");
	}
	ContactForm.prototype.standardInitData = function(e){
		const questionList = this.page.questions;
		if(questionList) {
			this.literals.questions = this.getQuestions(this.page.questions); //this.page.questionDetails;
		}
	}
	/*
	ContactForm.prototype.toggleNextQuestion = function($elem, state="toggle") {
		console.log("state:", state);

		/*
		const buttonTriggersShowing = $elem.hasClass('js-show-next-field');
		const showNextQuestion = (state === "toggle") ? !buttonTriggersShowing :
*
		let questionState = (state !== null) ? !state : !$elem.hasClass('js-show-next-field');
		console.log("q state:", questionState);
		const $nextQuestion = $elem.parents('.question').next('.js-reveal-question');
		console.log("NQ", $nextQuestion);
		if($nextQuestion) $nextQuestion.toggleClass('hidden', !questionState);
	}
	ContactForm.prototype.setupReveals = function(e) {
		const $buttons = $('.js-buttons').find('a');
		if($buttons.length)	$buttons.on('click', (e) => {
			const $this = $(e.currentTarget);
			this.toggleNextQuestion($this);
			if(this.recalcVisibilities) this.recalcVisibilities();
		});

		/*
		const $nextFields = $(".js-show-next-field");
		$nextFields.each((index, e) => {
			const $this = $(e);
			if($this.hasClass('selected')){
				console.log("It's selected!");
				this.toggleNextQuestion($this, true);
			}
		});
		*

		if(this.recalcVisibilities) this.recalcVisibilities();
	}
	*/
	ContactForm.prototype.additionalQuestions = function() {
		return [
			// {
			// 	name: "additional-questions",
			// 	input: "buttons",
			// 	inputType: "single",
			// 	required: true,
			// 	labels: "Do you have any questions?",
			// 	answers: [
			// 		{ labels: "Yes", name: "yes", showNextField: true},
			// 		{ labels: "No",  name: "no"},
			// 	],
			// },
			// {
			// 	name: "additional-questions",
			// 	input: "textarea",
			// 	inputType: "single",
			// 	required: false,
			// 	labels: "Would you like to ask us anything?",
			// 	placeholder: "Tell us what you're looking for"
			// },{
			// 	name: "contact",
			// 	input: "buttons",
			// 	inputType: "single",
			// 	required: true,
			// 	labels: "What is the best way to contact you?",
			// 	answers: [
			// 		{ labels: "Email", 	name: "email"},
			// 		{ labels: 'Phone', 	name: "phone"}
			// 	],
			// 	priority: 2,
			// },
			/*{
				name: "full-name",
				input: "text",
				required: true,
				labels: "Please tell us your name",
				placeholder: "Type your name here",
				priority: 1,
			},{
				name: "email",
				input: "text",
				required: true,
				labels: "Please enter your email address",
				placeholder: "Type your email address",
				priority: 2,
				contact: true,
			},{
				name: "phone",
				input: "text",
				required: true,
				labels: "Please enter your phone number",
				placeholder: "Type your phone number",
				priority: 3,
			},
			{
				name: "your-requirements",
				input: "text",
				required: false,
				labels: "Your requirements",
				placeholder: "Type requirements here",
				priority: 4,
			}	*/		
			// {
			// 	name: "suitable-time",
			// 	input: "text",
			// 	required: true,
			// 	labels: "What time is suitable for us to call you?",
			// 	placeholder: "e.g Anytime before 7pm",
			// 	priority: 4,
			// }
		];
	}
	ContactForm.prototype.additionalPages = function() {
		if(this.singlePage) {
			// console.log(this.values);
			return [];
		} else {
			return [
				{ name: "details",		questions: ['full-name','email','phone','your-requirements'], submissionUrl: "/forms/contact/popup/" },
				{ name: "complete", 	count: false }

				// { name: "questions", 	questions: ['additional-questions'] },
				// { name: "contact", 		questions: ['contact'] },
				// { name: "details",		questions: ['full-name','phone','suitable-time'], include: () => this.values.contact === "phone", count: false, submissionUrl: "/forms/contact/popup//" },
				// { name: "details",		questions: ['full-name','email'], include: () => (this.values.contact === "email"), count: false, submissionUrl: "/forms/contact/popup/" },
				// { name: "complete", 	count: false }
			];
		}
	}
	//Factory methods
	ContactForm.build = function(section, service){
		const parts = section.split("-");
		const className = "ContactForm" + parts.reduce( (str,part) => str + part.substr(0,1).toUpperCase() + part.substr(1), "");
		const classConstructor = eval(className);
		return new classConstructor({
			service: service ? service : false,
		});
	}